import {AbstractControl, ValidationErrors, ValidatorFn} from "@angular/forms";

/**
 * Validator function that checks if two password fields match.
 * Returns a 'mismatch' error if the passwords don't match.
 *
 * @param passwordField - The name of the password field
 * @param confirmPasswordField - The name of the confirm password field
 * @returns A validator function for use with FormGroup
 */
export function passwordMatchValidator(
  passwordField: string,
  confirmPasswordField: string
): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const password = group.get(passwordField);
    const confirm = group.get(confirmPasswordField);

    if (!password || !confirm) {
      return null;
    }

    if (password.value && confirm.value && password.value !== confirm.value) {
      confirm.setErrors({
        ...(confirm.errors ?? {}),
        mismatch: true,
      });
      return { mismatch: true };
    }

    // remove only mismatch, keep other errors (e.g. required)
    if (confirm.errors?.['mismatch']) {
      const { mismatch, ...rest } = confirm.errors;
      confirm.setErrors(Object.keys(rest).length ? rest : null);
    }

    return null;
  };
}
